import { RestClient } from '@/api/rest-client'
import { Comment } from '@/api/model/comment'

export class CommentClient extends RestClient<Comment> {
    collectionName = 'comments'
    parseData = Comment.fromData

    async create(data: Comment): Promise<Comment> {
        await this.client.post(`${this.basePath}/${this.collectionName}`, data)
        return await this.get(data.id, true)
    }

    async update(id: string, data: any): Promise<Comment> {
        await this.client.put(`${this.basePath}/${this.collectionName}/${id}`, data)
        return await this.get(id, true)
    }

    async delete(id: string): Promise<void> {
        await this.client.delete(`${this.basePath}/${this.collectionName}/${id}`)
    }
}
